import {
    CookieService
  } from "./cookie_service";
  import * as Video from "twilio-video";
  
  export const VIDEO_CAMERA_SELECTED_ID_COOKIE_STRING = "VIDEO_CAMERA_SELECTED_ID_COOKIE_STRING";
  export const VIDEO_MIC_SELECTED_ID_COOKIE_STRING = "VIDEO_MIC_SELECTED_ID_COOKIE_STRING";
  export const VIDEO_SPEAKER_SELECTED_ID_COOKIE_STRING = "VIDEO_SPEAKER_SELECTED_ID_COOKIE_STRING";
  export const VIDEO_CITIZEN_COOKIE_COMPONENT = "VIDEO::CITIZEN";
  export const VIDEO_DISPATCH_COOKIE_COMPONENT = "VIDEO::DISPATCH";
  
  export class VideoService {
  
    VIDEO_SHOW_MIC_CAMERA_DIALOG_COOKIE_BOOLEAN = "VIDEO_SHOW_MIC_CAMERA_DIALOG_COOKIE_BOOLEAN";
    VIDEO_IS_MIC_ON_COOKIE_BOOLEAN = "VIDEO_IS_MIC_ON_COOKIE_BOOLEAN";
    VIDEO_IS_CAMERA_ON_COOKIE_BOOLEAN = "VIDEO_IS_CAMERA_ON_COOKIE_BOOLEAN";
    VIDEO_SELF_MEDIA_POS_COOKIE_STRING = "VIDEO_SELF_MEDIA_POS_COOKIE_STRING";
  
    constructor(cookieService = new CookieService()) {
      /* eslint-disable */
      this.cookieService = cookieService;
    }
  
    async requestMediaAccess() {
      let isCameraAvailable = false;
      await navigator.mediaDevices.getUserMedia({
        video: true
      }).then((stream) => {
        isCameraAvailable = true;
        stream.getTracks().forEach(track => {
          track.stop();
        })
      }).catch(err => {
        isCameraAvailable = false;
      });
  
      const mediaStreamConstraints = {
        video: isCameraAvailable,
        audio: {
          ideal: {
            echoCancellation: true,
            noiseSuppression: true,
          }
        }
      };
  
      const media = await navigator.mediaDevices.getUserMedia(mediaStreamConstraints)
        .catch(mediaError => {
          return mediaError;
        });
  
      if (media.message) {
        return media;
      } else {
        const tracks = media.getTracks();
        tracks.forEach(track => {
          track.stop();
        });
      }
  
      return undefined;
    }
  
    async attachTrack(track, container, selectedSpeakerId) {
      let child;
      if (track.kind === 'audio' && selectedSpeakerId) {
        const audioElem = track.attach();
        await audioElem.setSinkId(selectedSpeakerId);
        child = container.appendChild(audioElem);
      } else {
        child = container.appendChild(track.attach());
        child.style.height = '100%';
        child.style.width = '100%';
      }
  
      return child;
    }
  
    muteLocalTrack(
      localTrack, activeRoom) {
      if (localTrack) {
        localTrack.stop();
        localTrack.disable();
        this.detachTrack(localTrack);
        if (activeRoom) {
          activeRoom.localParticipant.unpublishTrack(localTrack);
        }
      }
    }
  
    detachTrack(track) {
      if (track) {
        track.detach().forEach((element) => {
          element.remove();
        });
      }
    }

    async getMediaDevices() {
      const mediaDeviceList = await navigator.mediaDevices.enumerateDevices();
      return mediaDeviceList;
    }
  
    getMediaDeviceList(mediaDeviceList, isDispatch) {
      const returnCameraList = [];
      const returnMicList = [];
      const returnSpeakerList = [];
      /* eslint-disable */
      // console.log("getMediaDeviceList", mediaDeviceList);
  
      mediaDeviceList.forEach(mediaDevice => {
        switch (mediaDevice.kind) {
          case 'videoinput':
            const camera = returnCameraList.find((cameraDevice) => {
              return cameraDevice.deviceId === mediaDevice.deviceId;
            });
            if (!camera) {
              returnCameraList.push(mediaDevice);
            }
            break;
          case 'audioinput':
            const mic = returnMicList.find((micDevice) => {
              return micDevice.deviceId === mediaDevice.deviceId;
            });
            if (!mic) {
              returnMicList.push(mediaDevice);
            }
            break;
          case 'audiooutput':
            const speaker = returnSpeakerList.find((speakerDevice) => {
              return speakerDevice.deviceId === mediaDevice.deviceId;
            });
            if (!speaker) {
              returnSpeakerList.push(mediaDevice);
            }
            break;
        }
      });
  
      let returnCameraSelectedId = this.getCookieString(VIDEO_CAMERA_SELECTED_ID_COOKIE_STRING, isDispatch);
      let returnMicSelectedId = this.getCookieString(VIDEO_MIC_SELECTED_ID_COOKIE_STRING, isDispatch);
      let returnSpeakerSelectedId = this.getCookieString(VIDEO_SPEAKER_SELECTED_ID_COOKIE_STRING, isDispatch);
  
      if (!returnMicSelectedId && returnMicList.length > 0) {
        returnMicSelectedId = returnMicList[0].deviceId;
      }
  
      if (!returnCameraSelectedId && returnCameraList.length > 0) {
        // if (returnCameraList.length === 2) {
        //     returnCameraSelectedId = returnCameraList[1].deviceId;
        // } else {
        returnCameraSelectedId = returnCameraList[0].deviceId;
        // }
      }
  
      if (!returnSpeakerSelectedId && returnSpeakerList.length > 0) {
        returnSpeakerSelectedId = returnSpeakerList[0].deviceId;
      }
  
      return {
        cameraList: returnCameraList,
        micList: returnMicList,
        speakerList: returnSpeakerList,
  
        cameraSelectedId: returnCameraSelectedId,
        micSelectedId: returnMicSelectedId,
        speakerSelectedId: returnSpeakerSelectedId,
      }
    }
  
    getCookieString(cookieName, isDispatch) {
      /* eslint-disable */
      // console.log("getCookieString: " + cookieName);
      return this.cookieService.getCookieString(isDispatch ?
        VIDEO_DISPATCH_COOKIE_COMPONENT :
        VIDEO_CITIZEN_COOKIE_COMPONENT, cookieName);
    }
  
    async connectToVideoRoom(token, resourceId, enableVideo = false, enableAudio = false) {
      return new Promise((resolve, reject) => {
        if (token && resourceId) {
          const connectionOptions = {
            name: resourceId,
            // logLevel: 'warn',
            // recordParticipantsOnConnect: true,
            maxParticipants: 4,
            type: 'group-small',
            video: enableVideo,
            audio: enableAudio,
            tracks: [],
          };
  
          const videoRoom = Video.connect(token, connectionOptions)
            .catch((videoError) => {
              reject(videoError);
            });
  
          if (videoRoom) {
            resolve(videoRoom);
          }
        } else {
          reject(error);
        }
      });
    }
  }